<template>
    <div class="navbar-container">
      <b-navbar class="navbar navbar-fixed-top" toggleable="md" type="dark" sticky>
        <b-navbar-brand to="/">Weinprobe Grunbach</b-navbar-brand>

        <b-navbar-toggle target="nav-collapse"></b-navbar-toggle>

        <b-collapse id="nav-collapse" is-nav> 
          <b-navbar-nav>

            <!-- <b-nav-item-dropdown text="Stände">
              <b-dropdown-item to="Stand1">Stand 1</b-dropdown-item>
              <b-dropdown-item to="Stand2">Stand 2</b-dropdown-item>
              <b-dropdown-item to="Stand3">Stand 3</b-dropdown-item>
              <b-dropdown-item to="Stand4">Stand 4</b-dropdown-item>
            </b-nav-item-dropdown> -->

            <b-nav-item to="Karte">Übersichtskarte</b-nav-item>
            <b-nav-item to="Anfahrt">Anfahrt</b-nav-item>
          </b-navbar-nav>

          <!-- Right aligned nav items -->
          <b-navbar-nav class="ml-auto">
            <b-nav-item to="Impressum">Impressum</b-nav-item>
          </b-navbar-nav> 
        </b-collapse>
      </b-navbar>
    </div>
</template>

<script>
export default {
  name: 'navbar',
  components: {
    
  }
}
</script>

<style lang="scss" scoped>
  .navbar {
    background-color: $weinprobe-red;
  }

  .navbar-fixed-top {
    position: fixed;
    z-index: 999;
    width: 100%;
  }

  .navbar-container {
    height: 3.5em;
  }
</style>

